module.exports = __webpack_public_path__ + "img/053-snowy-2.5892b656.svg";